

export class Usertf{
    UserID:number;
    Email:string='';
    PhoneNo:string ='';
    Type:string ='';
    AuthChannelValue: string ='';
    AuthType: string = '';
    verificationcode: string = ''
}